/* eslint-disable max-len */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'app/AppStore';
import { ErrorWithLabel } from 'components/DataContainer';
import { getUniversalProductTechnicalCharacteristicsLabel } from 'components/StockInfo/catalogStockUtils';
import { getUniversalProduct } from 'domains/catalog/Catalog.store';
import { RENATIVE_LABEL, RENATIVE_TECHNICAL_CHARACTERISTICS_CODE } from 'domains/catalog/Catalog.types';
import { getSparePartsView } from 'domains/user';
import { ProductPreview } from 'UI/ProductPreview';
import { ProductPreviewCard } from 'UI/ProductPreview/ProductPreview.styled';
import { getData, isError } from 'utils';

export interface UniversalProductProps {
  referenceNumber: string;
}

const UniversalProduct = React.memo(({ referenceNumber }: UniversalProductProps) => {
  const { t } = useTranslation();
  const sparePartsView = useSelector(getSparePartsView);
  const universalProductReference = useSelector((state: RootState) => getUniversalProduct(state, referenceNumber));
  const universalProductReferenceData = getData(universalProductReference);
  const universalProductHasError = isError(universalProductReference);
  const renative =
    getUniversalProductTechnicalCharacteristicsLabel(
      universalProductReferenceData,
      RENATIVE_TECHNICAL_CHARACTERISTICS_CODE,
    ) === RENATIVE_LABEL;

  if (universalProductHasError) {
    return (
      <ProductPreviewCard direction={'column'} minWidth={300} maxWidth={300} minHeight={500} align={'center'}>
        <ErrorWithLabel
          label={t(
            'catalog.universal_products.backend_error',
            'This Universal product is temporarily unavailable, please try again later.',
          )}
        />
      </ProductPreviewCard>
    );
  }

  return (
    <ProductPreview
      imageUrl={universalProductReferenceData?.imageKey}
      productName={universalProductReferenceData?.productName}
      referenceNumber={referenceNumber}
      sparePartsView={sparePartsView}
      renative={renative}
      isUniversalProduct
    />
  );
});

UniversalProduct.displayName = 'UniversalProduct';

export default UniversalProduct;
